export enum POPUP_TYPE {
  Member = 1,
  Points = 2,
  Reward = 3,
}
